exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 317px ) {\r\n    .dashboard-m-t-45{\r\n        margin-top: 75px;\r\n    }\r\n\r\n}\r\n@media (max-width: 317px ) {\r\n    .dashboard-m-t-45{\r\n        margin-top: 75px;\r\n    }\r\n\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    .dashboard-m-t-45{\r\n        margin-top: 45px;\r\n    }\r\n\r\n}\r\n\r\n@media (min-width: 767px) {\r\n    .dashboard-m-t-45{\r\n        margin-top: 45px;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .dashboard-m-t-45{\r\n        margin-top: 45px;\r\n    }\r\n}\r\n\r\n\r\n@media (min-width: 1200px) {\r\n    .dashboard-m-t-45{\r\n        margin-top: 45px;\r\n    }\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = 0